import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopMemberRecommend(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input">
      <h2 className="pop_tit">이지 직원 소개 등록</h2>
      <div className="content_container scroll">
        <section className="search search_top">
          <input type="search" placeholder="직원명 검색" className="input s type_search" />
          <button className="com_btn gray ws s icon_search"></button>
        </section>
        <hr className="com_divider" />
        <ul className="com_input_sec type_col2">
          <li className="input_row">
            <div className="tit_field">직원 선택</div>
            <div className="input_field">
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">부서 선택</div>
            <div className="input_field">
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">직급 선택</div>
            <div className="input_field">
              <select className="select">
                <option value="선택">선택</option>
              </select>
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">직책 입력</div>
            <div className="input_field">
              <input type="text" className="input" placeholder="배정팀, 채용팀 총괄." />
            </div>
          </li>
          <li className="input_row full">
            <div className="tit_field">입사일</div>
            <div className="input_field">
              <div className="date_wrap">
                <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
              </div>
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">내선번호</div>
            <div className="input_field">
              <input type="text" className="input" defaultValue={`1654`} />
            </div>
          </li>
          <li className="input_row">
            <div className="tit_field">전화번호</div>
            <div className="input_field">
              <input type="text" className="input" defaultValue={`010-1234-1234`} />
            </div>
          </li>
          <li className="input_row full">
            <div className="tit_field">사진 등록</div>
            <div className="input_field">
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
            </div>
          </li>
          <li className="input_row full">
            <textarea className="textarea" placeholder="내용 입력"></textarea>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopMemberRecommend;
